module.exports = __webpack_public_path__ + "img/wlxxaq_s.0657a59.png";